import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../components/Style/breakpoints';
import { Button } from '../../../../components/Marketing/Button';
import { UniCardProps } from './types';

const InstitutionCardContainer = styled(Flex)`
  background: linear-gradient(
      11.7deg,
      #f8f6f8 36.95%,
      rgba(255, 255, 255, 0) 97.42%
    ),
    #f6f8f8;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
  border-radius: 30px;
  padding: 30px;
`;

const Content = styled(Flex)`
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 4;
  padding: 0 30px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

// const Description = styled(Box)`
//   font-family: Avenir, sans-serif;
//   font-style: normal;
//   font-weight: normal;
//   font-size: 16px;
//   line-height: 140%;
//   color: #3e4b4c;
//   @media only screen and (min-width: ${HOMEPAGE_BREAKPOINT_DESKTOP}) {
//   }
// `;

const Header = styled(Box)`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 26px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
  }
`;

const Logo = styled('img')`
  height: 100px;
`;

export const UniCard = ({ institutions }: UniCardProps): ReactElement => {
  return (
    <>
      {institutions.length === 1 && (
        <InstitutionCardContainer>
          <Box minWidth="100px">
            <Logo
              src={institutions[0].logoUrl}
              alt={`Logo of ${institutions[0].name}`}
            />
          </Box>

          <Content>
            <Header>{institutions[0].name}</Header>
            {/* <Description>{institution.description}</Description> */}
          </Content>
          <Flex alignItems="center" width="192px" minWidth="100px">
            <Button
              variant="primary"
              action={{
                kind: 'external_link',
                value: institutions[0].url,
              }}
            >
              Learn more
            </Button>
          </Flex>
        </InstitutionCardContainer>
      )}
    </>
  );
};
